/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const changeOrConfigurationErrorEnumsCurrentStatusOptionEnum = {
    Online: 'Online',
    Offline: 'Offline',
    Busy: 'Busy',
    Overwhelmed: 'Overwhelmed',
    Saturated: 'Saturated',
    Other: 'Other',
} as const;

export type ChangeOrConfigurationErrorEnumsCurrentStatusOptionEnumKey =
    (typeof changeOrConfigurationErrorEnumsCurrentStatusOptionEnum)[keyof typeof changeOrConfigurationErrorEnumsCurrentStatusOptionEnum];

export type ChangeOrConfigurationErrorEnumsCurrentStatusOption =
    ChangeOrConfigurationErrorEnumsCurrentStatusOptionEnumKey;
